export const Errors = {
    InvalidNumber: 'invalid_chars',
    NegativeNumber: 'negative_number',
    OutOfRange: 'out_of_range',
    Required: 'required'
};

export const validateInput = (value, config) => {
    if (config.required && (!value || value.length < 1)) {
        return Errors.Required;
    }

    if (value.length > 0) {
        // Use the parser to validate the number
        try {
            value = config.parser.parse(value);
        } catch (err) {
            return Errors.InvalidNumber;
        }

        if (typeof value !== 'undefined' && !isNaN(value)) {
            let numberValue = +value;

            if (config.conversionFunction) {
                numberValue = config.conversionFunction.call(this, numberValue);
            }

            if (typeof config.minValue != 'undefined' && numberValue < config.minValue) {
                return Errors.OutOfRange;
            }

            if (typeof config.maxValue != 'undefined' && numberValue > config.maxValue) {
                return Errors.OutOfRange;
            }

            // Might be better served to replace this with minValue = 0. We get better error reporting this way though
            if (config.mustBePositive) {
                if (numberValue < 0) {
                    return Errors.NegativeNumber;
                }
            }
        } else {
            return Errors.InvalidNumber;
        }
    }
};

export default {
    validateInput,
    Errors
};
